<template>
    <div class="componentsCtn_1">
        <div class="top">
            <div class="top-name"><img style="width: 22px; height: 22px;margin-bottom: 10px;"
                    src="../../assets/外业移动核查审核人员.png" alt=""><span>我是审核人员</span></div>
        </div>
        <div class="signUp_content">
            <!--协同标注，任务列表-->
            <div class="componentCtn-main">
                <div class="searchPanel">
                    <div class="txt">
                        任务名称:
                    </div>
                    <div class="input" style="padding-right: 20px;">
                        <a-input size="large" v-model="InputTaskName" style="height: 40px;font-size: 14px;"
                            placeholder="请输入任务名称" />
                    </div>
                    <img src="../../assets/userCenter/查找.png" title="搜索" height="40" width="40"
                        style="margin-left: 25px;cursor: pointer;" @click="searchQue" />
                    <img src="../../assets/userCenter/重置.png" title="重置" height="40" width="40"
                        style="margin-left: 25px;cursor: pointer;" @click="reSetQue" />
                </div>
                <div class="tableCtn">
                    <a-config-provider :locale="locale" >
                        <a-table :columns="tableColumns" :data-source="tableData" :pagination="ipagination"
                            style="font-weight: 700" @change="handleTableChange">
                            <span slot="action" slot-scope="text, record">
                                <a @click="open(record.id)" style="color: RGBA(2, 128, 2, 1);">查看</a>
                            </span>
                        </a-table>
                    </a-config-provider>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
import moment from 'moment';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
    name: "auditor",
    data() {
        return {
            programId:"",
            /* 搜索区 */ 
            InputTaskName:"",
            /* 表格展示区 */
            tableColumns: [
                {
                    title: '任务名称',
                    dataIndex: 'name',
                    key: 'name',
                    align: 'center'
                },
                {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    align: 'center'

                },
                {
                    title: '图斑总数',
                    dataIndex: 'totalSum',
                    key: 'totalSum',
                    scopedSlots: { customRender: 'totalSum' },
                    align: 'center'

                },
                {
                    title: '已核查个数',
                    dataIndex: 'checkSum',
                    key: 'checkSum',
                    scopedSlots: { customRender: 'checkSum' },
                    align: 'center'

                },
                {
                    title: '未核查个数',
                    dataIndex: 'uncheckSum',
                    key: 'uncheckSum',
                    scopedSlots: { customRender: 'uncheckSum' },
                    align: 'center'

                },
                {
                    title: '创建人',
                    key: 'userName',
                    dataIndex: 'userName',
                    align: 'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center'

                },
            ],
            tableData: [],
            // tableData,
            /* 分页参数 */
            ipagination: {
                current: 1,
                pageSize: 10,
                // pageSizeOptions: ['10', '20', '30'],
                showTotal: (total, range) => {
                    return " 共" + total + "条"
                },
                showQuickJumper: true,
                // showSizeChanger: true,
                total: 0
            },
            locale: zhCN,


            
            


        }
    },
    methods: {
        searchQue() {
            this.loadData();
        },
        reSetQue() {
            this.InputTaskName = ''
            this.ipagination.current = 1
            this.loadData();
        },
        //跳转审核页面
        open(id){
            console.log('taskId',id)
            this.$router.push({path:'/examine',query:{taskId:id}})
        },
        getKey() {
            return localStorage.getItem("token");
        },
        handleTableChange(pagination, filters, sorter) {
            //分页、排序、筛选变化时触发
            //TODO 筛选
            if (Object.keys(sorter).length > 0) {
                this.isorter.column = sorter.field;
                this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
            }
            this.ipagination = pagination;
            this.loadData();
        },
        loadData() {
            //获取审核人员任务列表
            this.axios({
                method: 'post',
                url: '/tilesapi/tiles/task/field/task/list',
                headers: {
                    Authorization: "Bearer " + this.getKey(),
                },
                params: {
                    pageNo: this.ipagination.current,
                    pageSize: this.ipagination.pageSize,
                    taskName: this.InputTaskName,
                    // programId: this.programId
                }
            }).then((response) => {
                this.tableData = response.data.data.records
                this.ipagination.total = response.data.data.records.length
            })
        },


    },
    mounted() {
        // this.programId = this.$route.query.programId
        this.loadData()

        //获取我的任务对应的所有任务列表
        // this.loadDataAudit()

        this.frameUrlOld = this.frameBaseUrl + `/analysisTask/SampleLabelAudit?token=${this.getKey()}&project=0`

    }
}
</script>

<style scoped lang="scss">
.detailCtn {
    .table1 {
        width: 667px;

        .tr1 {
            height: 40px;
            line-height: 40px;
            width: 100%;
        }

        .td1 {
            width: 200px;
        }

        .blod {
            font-weight: bold;
        }
    }
}

::v-deep .ant-table-thead>tr>th {
    font-weight: 700;
}

.tableCtn {
    width: calc(100% - 86px);
    height: 500px;
    // margin-top: 46px;
    margin-left: 43px;
    margin-right: 43px;
}

.searchPanel {
    width: calc(100% - 86px);
    height: 40px;
    position: relative;
    display: flex;
    justify-content: left;
    margin: 33px 43px ;

    .txt {
        width: 85px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
    }

    .input {
        width: 200px;
        height: 40px;
        line-height: 40px;
    }
}

.bash_iframe {
    width: calc(100% - 20px);
}

.signUp_content {
    width: calc(100% - 133px);
    height: calc(100% - 84px);
    // overflow-y: auto;
    margin-bottom: 35px;

    .componentCtn-main {
        background-color: RGBA(245, 245, 245, 1);
        border-radius: 8px;
        position: relative;
        width: 100%;
        // min-height: 570px;
        height: calc(100% - 70px);
        // display: flex;
        // justify-content: left;
        // flex-flow: wrap;
        overflow: hidden;
    }

}

/*滚动条样式*/
.signUp_content::-webkit-scrollbar {
    width: 4px;
}

.signUp_content::-webkit-scrollbar-thumb {
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(0, 0, 0, 0.2);
}

.signUp_content::-webkit-scrollbar-track {}

.selectPanel {
    height: 30px;
    line-height: 30px;
    width: 100%;
    position: relative;
}

.top {
    margin: 35px 0;

    .top-name {
        display: inline-block;
        width: 171px;
        height: 39px;
        background: rgba(0, 102, 204, 0.35);
        border-radius: 4px;
        overflow: hidden;
        padding: 6px 10px 14px;;
    }

    span {
        width: 143px;
        height: 28px;
        font-size: 20px;
        font-family: PingFangSC-Semibold, PingFang SC;
        color: #0066CC;
        line-height: 28px;
        margin-left: 8px;
    }
}

.componentsCtn_1 {
    background-image: url(../../assets/套件智慧工具背景.png);
    background-size: cover;
    width: 100%;
    height: calc(100% - 76px);
    margin-top: 76px;
    //   height: auto;
    //   background: #F5F5F6;
    padding-left: 133px;
    overflow: hidden;
}
</style>